import React from "react";

const QuoteTariffInfoBox = ({ quote }) => {
  const totalExitFee = (
    parseFloat(quote?.exitFeeElec || 0) + parseFloat(quote?.exitFeeGas || 0)
  ).toFixed(2);

  return (
    <div className="mt-6">
      <div className="border border-[#afb6b9] rounded-[4px] px-4 py-2">
        <table className="w-full table-fixed">
          <tbody className="divide-y divide-[#afb6b9]">
            <tr className="align-top">
              <td className="font-medium py-3">Contract type:</td>
              <td className="py-3">{quote?.tariffType}</td>
            </tr>
            <tr className="align-top">
              <td className="font-medium py-3">Total exit fee:</td>
              <td className="py-3">£{totalExitFee}</td>
            </tr>
            <tr className="align-top">
              <td className="font-medium py-3">Green tariff:</td>
              <td className="py-3">{quote?.GreenTariff ? "Yes" : "No"}</td>
            </tr>
            <tr className="align-top">
              <td className="font-medium py-3">Payment method:</td>
              <td className="py-3">
                {quote?.tilPayTypeElec || quote?.tilPayTypeGas}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default QuoteTariffInfoBox;
